import CSVReport from "@/services/CSVReport.js";

function fileDownload(fileName, content, fileType) {
  var blob = new Blob([content], { type: fileType });
  if (navigator.msSaveBlob) {
    // IE 10+
    navigator.msSaveBlob(blob, fileName);
  } else {
    var link = document.createElement("a");
    if (link.download !== undefined) {
      // feature detection
      // Browsers that support HTML5 download attribute
      var url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", fileName);
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
}

function remoteFileDownload(url) {
  var link = document.createElement("a");
  if (link.download !== undefined) {
    // feature detection
    // Browsers that support HTML5 download attribute
    link.setAttribute("download", "");
    link.style.visibility = "hidden";
    document.body.appendChild(link);

    link.setAttribute("href", url);
    link.click();

    document.body.removeChild(link);
  } else {
    window.open(url, "_blank");
  }
}

function jsonToCSV(items, options = {}) {
  let { delimiter, replacementCharacter, excludedProps } = options;
  return CSVReport.jsonToCSV(
    items,
    delimiter,
    replacementCharacter,
    excludedProps
  );
}

export default { jsonToCSV, fileDownload, remoteFileDownload };
